export enum UserType{
  Federated = "0",
  Local = "1",
  SSOPortalAdmin = "2"
}

export const UserTypeDisplayValue: Record<UserType, String> = {
  [UserType.Federated]: "Federated User",
  [UserType.SSOPortalAdmin]: "SSO Portal Admin",
  [UserType.Local]: "Local User"
};
